import React from 'react';

import {WebsiteModuleProps} from "../models/website-module.props";
import {WebsiteModuleContent} from "./website-module.content";
import {observer} from 'mobx-react';
import {MegaHeaderModuleAsync} from "../modules/mega-header/components/mega-header-module.async";
import {WebsiteModuleSideBar} from "./conditional/website-module.side-bar";
import styles from "../styles/website.module.scss";
import classNames from "classnames";
import {Breadcrumbs} from "../../../core/components/breadcrumbs/breadcrumbs";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";
import {WebsiteModuleMainTop} from "./website-module.main.top";
import {useVignetteTargeting} from "../../../infrastructure/hooks/ads/useAdVignetteSetTargeting";
import {WebsiteModuleWideDesktopMain} from "./website-module.wide-desktop-main";

export class WebsiteModuleBodyComponentProps extends WebsiteModuleProps {
}

const WebsiteModuleMain = observer(({controller}: WebsiteModuleBodyComponentProps) => {
  const {state} = controller;

  const {breadcrumbsManager, displaySettings, shouldRenderAdsBorders} = state;

  useVignetteTargeting(['/pt-br/apostas']);

  const breadcrumbsProps = {
    controller,
    visible: breadcrumbsManager.showBreadcrumbs,
    hasData: breadcrumbsManager.hasBreadcrumbs
  }

  return (
    <ErrorBoundaryWrapper isMandatory>
      <main>
        {
          displaySettings.isNewEntitiesPages ? <WebsiteModuleContent controller={controller}/> :
            <>
              <Breadcrumbs {...breadcrumbsProps} />
              <MegaHeaderModuleAsync/>
              {
                !displaySettings.isBettingZone ? <WebsiteModuleMainTop controller={controller}/> : null
              }
              {
                !displaySettings.isBettingZone && shouldRenderAdsBorders ? <WebsiteModuleWideDesktopMain controller={controller}/> :
                  <div className={classNames(styles.main, {[styles.is_bolao]: displaySettings.isBolao, [styles.is_betting_zone]: displaySettings.isBettingZone})}>
                    <WebsiteModuleSideBar controller={controller}/>
                    <WebsiteModuleContent controller={controller}/>
                  </div>
              }
            </>
        }
      </main>
    </ErrorBoundaryWrapper>
  );
});

export default WebsiteModuleMain;
